export function resetLocalStorageAfterAttendance() {
    const auth = localStorage.getItem('auth');
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const theme = localStorage.getItem('theme') || 'light';

    // 1. Clear ALL storage
    localStorage.clear();

    // 2. Restore/Initialize exactly 10 keys from login state
    const cleanLoginState = {
        auth,
        isLoggedIn: isLoggedIn || 'true',
        theme,
        dailyTask: null,
        runningTasks: JSON.stringify([]),
        checkedTasks: JSON.stringify([]),
        shift_overtime_history: JSON.stringify([]),
        shift_overtime_remarks_history: JSON.stringify([]),
        taskButtonStates: JSON.stringify([]),
        tomorrowTask: JSON.stringify([])
    };

    Object.entries(cleanLoginState).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            localStorage.setItem(key, value);
        } else if (value === null) {
            // Explicitly set some to null if they should be null (like dailyTask)
            localStorage.setItem(key, 'null');
        }
    });

    // Handle dailyTask specifically because JSON.parse(null) is fine but 'null' string is safer for some parsers
    localStorage.setItem('dailyTask', 'null');
}